// extracted by mini-css-extract-plugin
module.exports = {"main":"DarkenBackground_main__34TB9"};